import getConfig from '@config';
const { SVC_HR_BASE_URL, SVC_HR_JWT_ID } = getConfig();

import axios from 'axios';
import jwt, { applyJwtInterceptor } from '@webapp-next/lib/request/utils/jwt';

const http = axios.create({
  crossdomain: true,
  // baseURL,
  // timeout: 1000,
  // TODO: use this function to replace the code repetition
  // transformResponse: [function (data) {
  //   // Do whatever you want to transform the data
  //   console.error('####22', data);
  //
  //   return data;
  // }],
});

http.interceptors.request.use(function(config) {
  const baseURL =
    SVC_HR_BASE_URL || `https://${window.__APP__.API_REGION_HOSTNAME}/hr/v1`;

  config.url = `${baseURL}${config.url}`;
  return config;
});

const jwtConfig = {
  aud: SVC_HR_JWT_ID,
  claims: {
    deputy_user_id: '',
    deputy_business_id: '',
    deputy_employee_profile_id: '',
    deputy_business_user_id: '',
    deputy_business_location_id: '',
  },
};

applyJwtInterceptor(http, jwtConfig);

export async function getJwt() {
  return jwt(jwtConfig);
}

export default http;
